import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Grid, TextField } from "@material-ui/core"
import { obtenerAgentes } from "../../../ducks/usuariosDuck"
import { obtenerComisionesAgente, valorAgente, obtenerComisionesAgentePagadas } from "../../../ducks/cotizacionDuck"
import { Autocomplete } from "@material-ui/lab"
import handleRenderOption from "./handleRenderAgente"
import FiltroFecha from "../FiltroFecha"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
const useObtenerAgentes = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({}))
        dispatch(obtenerAgentes()).then((Response) => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const CbAgentes = ({ esPago, esReporte }) => {
    const dispatch = useDispatch()
    const agentes = useSelector(store => store.usuarios.agentes)
    useObtenerAgentes()
    const handleSelecAgente = (event, valor) => {
        if (!valor)
            return null
        dispatch(onLoadAnction({}))
        dispatch(valorAgente(valor.UserName))
        if (esPago) {
            dispatch(obtenerComisionesAgente()).then((Response) => {
                dispatch(offLoadAction())
            })
        }
        else if (esReporte) {
            dispatch(obtenerComisionesAgentePagadas()).then((Response) => {
                dispatch(offLoadAction())
            })
        }
    }

    return (
        <div style={{ marginBottom: "2rem", marginTop: "2rem" }}>
            <Grid container>
                <Grid item xs={4}>
                    <Autocomplete
                        id={`id-auto-Agentes`}
                        options={agentes.sort((a, b) => a.Nombres > b.Nombres)}
                        getOptionLabel={(option) => `${option.UserName} - ${option.Nombres}  ${option.ApellidoPaterno}  ${option.ApellidoMaterno}`}
                        style={{
                            width: "97%",
                            margin: "5px",
                            paddingBottom: "0",
                            fontWeight: "500",
                        }}
                        disabled={agentes.length > 0 ? false : true}
                        onChange={handleSelecAgente}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Agentes"
                                variant="outlined"
                                style={{ width: "100%" }}
                                name="agentes"
                            />
                        )}
                        renderOption={handleRenderOption}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FiltroFecha />
                </Grid>
            </Grid>
        </div>
    )


}
export default CbAgentes